import { Component, OnInit } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../../services-page.service';

@Component({
  selector: 'app-service-data-analytics',
  templateUrl: './service-data-analytics.component.html',
  styleUrls: ['./service-data-analytics.component.css']
})
export class ServiceDataAnalyticsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
